/**
 * @description 出入库管理
 */
import request from "@/utils/request";

// 查询详情(出库、入库)
export function queryDetailById(id) {
    return request({
        url: `/bound/getDetailInfoV164/${id}`,
        method: "get",
    });
}

// 查询详情(出库、入库)
export function queryRequisitionDetailById(id) {
    return request({
        url: `/bound/getDetailInfoV164/${id}`,
        method: "get",
    });
}


// 新增（入库）
export function saveAcceptMaterialV164(data) {
    return request({
        url: "/bound/saveAcceptMaterialV164",
        method: "post",
        data,
    });
}

// 编辑（入库）
export function updateAcceptMaterialV164(data) {
    return request({
        url: "/bound/updateAcceptMaterialV164",
        method: "post",
        data,
    });
}
